import { Direcciones } from './direcciones';

export class FiltroUsuarioControlCliModule {

  constructor(
    public idCliente: number = 0,
    public idGrupo: number[] = [],
    public rango: number = 0,
    public usuario: string = '',
    public email: string = ''
  ) { }
}

export class ClientesControlCliModule {

  constructor(
    public Id: number = 0,
    public DESCRIPCION: string = ''
  ) { }
}

export class FiltroGruposControlCliModule {

  constructor(
    public idCliente: number = 0,
    public idGroup: number = 0,
    public centroReferenciaExterna: string = ''
  ) { }
}

export class GrupoControlCliModule {

  constructor(
    public Id: number = 0,
    public DESCRIPCION: string = '',
    public CLIENTE: string = '',
    public CENTRO: string = ''
  ) { }
}

export class UsuariosControlCliModule {

  constructor(
    public contador: number = 0,
    public usuarios: Usuarios[]

  ) { }
}

export class Usuarios {

  constructor(
    public Id: number = 0,
    public NOMBRE: string = '',
    public APELLIDOS: string = '',
    public USUARIO: string = '',
    public EMAIL: string = '',
    public TELEFONO: string = '',
    public Grupo: GrupoControlCliModule,
    public GrupoPrincipal: string = '',
    public idGrupoPrincipal: number = 0,
    public Multiclient: MultiClientUser[],
    public Direcciones: UsuarioDireccion[],
    public RANGO: number = 0
  ) { }
}

export class UsuarioDireccion {

  constructor(
    public Direccion: Direcciones
  ) { }
}

export class MultiClientUser {

  constructor(
    public ID_GRUPO: number = 0,
    public ID_USUARIO: number = 0,
    public RANGO: number = 0,
    public PRINCIPAL: number = 0,
    public FECHA_CONCESION: Date = new Date(),
    public Id: number = 0,
    public Grupo: GrupoControlCliModule
  ) { }
}
